//
// WebContentElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "../../models/visualElements/webContent/WebContentElement";

var WebContentElementController = createModule("BIRD::WebContentElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::DataVisualElementController"], EventDispatcher, [
    {
        WEB_CONTENT_DISABLED: 50032,
    },
    ,
    ,
    ,
    {
        getModel: [1],
        dispatchSelectEvent: [0],
        hasData: [2],
        getJSONXData: [7],
        selectFromJSONX: [0,7],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default WebContentElementController;
